import React from 'react'

function BatteryImage({battery}) {

    //battery state of charge 
    let charge = battery.stateOfCharge === 'N/A' ? 0 : battery.stateOfCharge
    //modify charge state comply with css
    let styleCharge = 100 - charge

  return (
    <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
          <div className='rectangle1'></div>
          <div className='rectangle2'>
           
            <div style={{height:`${styleCharge}%`,  position:'relative', background:'lightGray', borderRadius: '8px 8px 0px 0px'}}>
              
              
            </div>
           
          </div>
          <p>{battery.stateOfCharge === null ?  'N/A' :  battery.stateOfCharge} % charged</p>
          
        </div>  
  )
}

export default BatteryImage